export default function kwipsDataSelector(func) {
  let { kwipReducer } = func((state) => state);
  return kwipReducer;
}
